import { Card } from "../../components//card/Card";
import { elencoservizi } from "../../config/elencoservizi.js";
import "./servizi.css";
import { Helmet } from "react-helmet";

export const Servizi = () => {
    return (
        <>
            <title>
                <Helmet>Servizi </Helmet>
            </title>
            <section id="servizi" className="pb-5">
                <h2 className="fs-1 text-center py-5 textBlue">Servizi</h2>
                <div className="container">
                    <div className="row">
                        {elencoservizi.map((service, index) => {
                            return (
                                <div className="col-sm-12 col-md-6 col-lg-4 my-2" key={service.title}>
                                    <Card obj={service} index={index} />
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>
        </>
    );
};
